import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { adminApi } from "../services/api";
import { useAuthStore, AdminRole } from "../stores/authStore";

export default function Login() {
  const navigate = useNavigate();
  const { setAuth } = useAuthStore();
  const [email,   setEmail]   = useState("");
  const [code,    setCode]    = useState("");
  const [step,    setStep]    = useState<"email" | "code">("email");
  const [loading, setLoading] = useState(false);
  const [error,   setError]   = useState("");

  async function sendOtp() {
    if (!email) return;
    setLoading(true); setError("");
    try {
      await adminApi.sendOtp(email);
      setStep("code");
    } catch (e: any) {
      setError(e.status === 403 ? "Email not authorised for admin access." : "Failed to send code. Try again.");
    } finally { setLoading(false); }
  }

  async function verify() {
    if (!code) return;
    setLoading(true); setError("");
    try {
      const res = await adminApi.verifyOtp(email, code);
      setAuth(res.token, email, res.role as AdminRole, res.permissions);
      navigate("/", { replace: true });
    } catch {
      setError("Invalid or expired code.");
    } finally { setLoading(false); }
  }

  return (
    <div style={{ minHeight: "100vh", display: "flex", alignItems: "center", justifyContent: "center", background: "var(--bg)" }}>
      <div className="card" style={{ width: 360, display: "flex", flexDirection: "column", gap: 16 }}>
        <div style={{ textAlign: "center", marginBottom: 8 }}>
          <div style={{ fontSize: 28, marginBottom: 6 }}>⚡</div>
          <div style={{ fontWeight: 900, fontSize: 18 }}>StarQuest Admin</div>
          <div style={{ color: "var(--text-muted)", fontSize: 13, marginTop: 4 }}>
            {step === "email" ? "Enter your email to receive a login code" : `Code sent to ${email}`}
          </div>
        </div>

        {step === "email" ? (
          <>
            <input
              autoFocus type="email" placeholder="admin@example.com" value={email}
              onChange={(e) => setEmail(e.target.value)}
              onKeyDown={(e) => e.key === "Enter" && sendOtp()}
              style={{ padding: "10px 14px", borderRadius: 8, border: "1px solid var(--border)", background: "var(--surface2)", color: "var(--text)", fontSize: 14 }}
            />
            <button className="btn btn-primary" onClick={sendOtp} disabled={loading || !email}>
              {loading ? "Sending…" : "Send Code →"}
            </button>
          </>
        ) : (
          <>
            <input
              autoFocus type="text" inputMode="numeric" maxLength={6}
              placeholder="123456" value={code}
              onChange={(e) => setCode(e.target.value.replace(/\D/g, ""))}
              onKeyDown={(e) => e.key === "Enter" && verify()}
              style={{ padding: "10px 14px", borderRadius: 8, border: "1px solid var(--border)", background: "var(--surface2)", color: "var(--text)", fontSize: 22, textAlign: "center", letterSpacing: "0.3em" }}
            />
            <button className="btn btn-primary" onClick={verify} disabled={loading || code.length < 6}>
              {loading ? "Verifying…" : "Verify →"}
            </button>
            <button className="btn" onClick={() => { setStep("email"); setCode(""); }}>← Back</button>
          </>
        )}

        {error && <div style={{ color: "#f87171", fontSize: 13, textAlign: "center" }}>{error}</div>}
      </div>
    </div>
  );
}
